var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list !== null && (!_vm.list || !_vm.list.length))?_c('div',[_c('img',{staticClass:"d-block d-sm-none",attrs:{"src":require('@/assets/images/pages/data-report.svg'),"alt":""}}),_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }